import i18nJson from '../../i18n.json';

const baseLanguage = i18nJson['base-language'];

export default baseLanguage['parachute-ui'];
